import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ButtonTemplate } from '../ButtonTemplate';
import * as styles from './AsyncErrorState.module.scss';
export const AsyncErrorState = ({ children, icon: Icon, iconSize, ...rest }) => {
    const iconClassNames = classNames('u-color-dark-gray', {
        [`u-icon-${iconSize}`]: iconSize,
    });
    const section = (_jsxs("section", { className: styles.section, children: [_jsx(Icon, { "aria-hidden": true, className: iconClassNames, "data-testid": "async-error-state-icon" }), _jsx("div", { className: "u-typography-h7 u-color-dark-gray u-text-center u-m-t-m", children: children })] }));
    if (!rest.onClick) {
        return section;
    }
    return (_jsx(ButtonTemplate, { ...rest, className: styles.button, type: "button", children: section }));
};
//# sourceMappingURL=AsyncErrorState.js.map